import { data, grid, series, axisPointer, dataZoom, axis, tooltip, markLine, markArea, projectColors } from './d3chartsOpt'
export { projectColors }

const animation = false;
// const fontFamily = undefined;
const fontFamily = 'DIN-Regular';

// 线和柱状图
export function lineAndBar(){
  return {
    textStyle: {
        fontFamily: fontFamily
    },
    animation: animation,
    axis: [
        axis.getBottomBar(),
        axis.getLeft(undefined, projectColors.red),
        axis.getRight('家', projectColors.blue)
    ],
    grid: [grid.doubleAxis],
    series: [ 
      series.getLine1('IPO金额', projectColors.red, 'IPO_amount'),
      series.getBar1({
        name: 'IPO数量',
        lineColor: projectColors.darkBlue,
        dataKey:'IPO_count'
      })
    ],
    data: [data.line3],
    tooltip: [
        tooltip.get1()
    ],
    axisPointer: [
        axisPointer.get1()
    ],
    dataZoom: [
      dataZoom.getDoubleAxis()
    ]
  }
}

// 1条区域线
export function line1(opt){
  return {
    textStyle: {
        fontFamily: fontFamily
    },
    animation: animation,
    data: [data.line3],
    grid: [grid.singleAxis],
    series: [
      series.getArea1(opt)
    ],
    dataZoom: [
      dataZoom.getSingleAxis()
    ],
    axis: [
      axis.getBottom(),
      axis.getLeft()
    ],
    tooltip: [
      tooltip.get1()
    ],
    axisPointer: [
      axisPointer.get1() 
    ]
  }
}

export function line1NoDataZoom(opt){
  var o = line1(opt);
  delete o.dataZoom;
  o.preventDefaultMouseWheel = false;
  o.axis[0] = axis.getBottom(false);
  o.grid[0] = grid.noDataZoomAxis;
  return o
}


// 2条区域线
export function line2(opt){
  // opt
  // {
  //  line1:
  //    {
  //      name:'销量 1', 
  //      lineColor, 
  //      dataKey:'x'
  //     }

  return {
    textStyle: {
        fontFamily: fontFamily
    },
    animation: animation,
    data: [data.line3],
    grid: [grid.singleAxis],
    series: [
      series.getArea1(opt.line1),
      series.getArea1(opt.line2)
    ],
    dataZoom: [
      dataZoom.getSingleAxis()
    ],
    axis: [
      axis.getBottom(),
      axis.getLeft()
    ],
    tooltip: [
      tooltip.get1()
    ],
    axisPointer: [
      axisPointer.get1() 
    ]
  }
}

// 3条区域线
export function line3(opt){
  return {
    preventDefaultMouseWheel: false,
    textStyle: {
        fontFamily: fontFamily
    },
    animation: animation,
    data: [data.line3],
    grid: [grid.noDataZoomAxis],
    series: [
      series.getArea1(opt.line1||{}),
      series.getArea1(opt.line2||{}),
      series.getArea1(opt.line3||{})
    ],
    axis: [
      axis.getBottom(false),
      axis.getLeft()
    ],
    tooltip: [
      tooltip.get1()
    ],
    axisPointer: [
      axisPointer.get1() 
    ]
  }
}

export function line2NoDataZoom(option){
  var opt = {
    preventDefaultMouseWheel: false,
    textStyle: {
        fontFamily: fontFamily
    },
    animation: animation,
    axis: [
        axis.getBottom(false),
        axis.getLeft()
    ],
    grid: [grid.noDataZoomAxis],
    series: [
      series.getLine1(option.line1.name, option.line1.lineColor, option.line1.dataKey),
      series.getLine1(option.line2.name, option.line2.lineColor, option.line2.dataKey)
    ],
    data: [data.line3],
    tooltip: [
        tooltip.get1()
    ],
    axisPointer: [
        axisPointer.get1()
    ]
  }
  return opt
}

export function line2DoubleAxisNoDataZoom(option){
  var opt = {
    preventDefaultMouseWheel: false,
    textStyle: {
        fontFamily: fontFamily
    },
    animation: animation,
    axis: [
        axis.getBottom(false),
        axis.getLeft(undefined, option.line1.lineColor),
        axis.getRight(undefined, option.line2.lineColor)
    ],
    grid: [grid.noDataZoomDoubleAxis],
    series: [
      series.getLine1(option.line1.name, option.line1.lineColor, option.line1.dataKey, undefined, 1),
      series.getLine1(option.line2.name, option.line2.lineColor, option.line2.dataKey, [0, 2])
    ],
    data: [data.line3],
    tooltip: [
        tooltip.get1()
    ],
    axisPointer: [
        axisPointer.get1()
    ],
    // markLine: [
    //   markLine.topToBottom(option.markLine)
    // ],
    // markArea: [
    //   markArea.topToBottom(option.markArea)
    // ]
  }
  return opt
}

export function line2DoubleAxis(option){
  let startValue, tooltipName = 'get1';
  if(option && option.dataZoom && option.dataZoom.startValue ) startValue = option.dataZoom.startValue
  if(option && option.tooltip ) tooltipName = option.tooltip
  var opt = {
    textStyle: {
        fontFamily: fontFamily
    },
    animation: animation,
    axis: [
        axis.getBottom(),
        axis.getLeft(undefined, option.line1.lineColor),
        axis.getRight(undefined, option.line2.lineColor)
    ],
    grid: [grid.doubleAxis],
    series: [
      series.getLine1(option.line1.name, option.line1.lineColor, option.line1.dataKey, undefined, 1),
      series.getLine1(option.line2.name, option.line2.lineColor, option.line2.dataKey, [0, 2])
    ],
    data: [data.line3],
    tooltip: [
        tooltip[tooltipName]()
    ],
    axisPointer: [
        axisPointer.get1()
    ],
    dataZoom: [
      dataZoom.getDoubleAxis(startValue)
    ]
  }

  return opt
}

// 标记区域
export function markLeftToRightArea(option){
  var opt = line2DoubleAxis(option);
  opt.markLine = [ markLine.leftToRight(option.markLine[0], option.markLine[1]) ];
  opt.markArea = [ markArea.leftToRight(option.markArea[0], option.markArea[1]) ];
  return opt
}

// 堆叠柱状图
export function stackBar(){
  return {
    textStyle: {
        fontFamily: fontFamily
    },
    preventDefaultMouseWheel: false,
    animation: animation,
    axis: [
        axis.getBottomBar(false),
        axis.getLeft()
    ],
    grid: [
      grid.noDataZoomAxis
    ],
    series: [
    {
      type: 'bar',
      $dataIndex: 0,
      dataKey: 'catch_fail_money',
      stack: '打板资金',
      name: '封板失败',
      itemStyle: {
        normal: {
          fill: projectColors.darkBlue
        }
      }
    },
    {
      type: 'bar',
      $dataIndex: 0,
      dataKey: 'catch_success_money',
      stack: '打板资金',
      name: '封板成功',
      itemStyle: {
        normal: {
          fill: projectColors.blackRed
        }
      }
    }
    ],
    data: [
      data.line3
    ],
    tooltip: [
        tooltip.get1()
    ],
    axisPointer: [
        axisPointer.get1()
    ]
  }         

}


export function oneCircle() {
  var s1 = series.getSingleArc();
  s1.animation = animation;
  s1.center[0] = '50%';

  return {
    preventDefaultMouseWheel: false,
    textStyle: {
        fontFamily: fontFamily
    },
    animation: animation,
    data: [{
      originData: [{
        min: 0,
        max: 100,
        title: '88环保',
        values: [
          { value: 80 }
        ]
      }]
    },{
      $dataIndex: 0,
      formatter: function (data) {
        if (!data.length) {return null;}
        return data[0];
      }
    }],
    series: [
      s1
    ]
  };
}

export function doubleCircle() {
  var s1 = series.getSingleArc();
  s1.animation = animation;
  s1.center[0] = '33%';

  var s2 = series.getSingleArc('arc2');
  s2.$dataIndex = 2;
  s2.center[0] = '66%';
  s2.animation = animation;

  return {
    preventDefaultMouseWheel: false,
    textStyle: {
        fontFamily: fontFamily
    },
    animation: animation,
    data: [{
      originData: [{
        min: 0,
        max: 100,
        title: '88环保',
        values: [
          { value: 80 }
        ]
      },{
        min: 0,
        max: 100,
        title: '节能环保',
        values: [
          { value: 8 }
        ]
      }]
    },{
      $dataIndex: 0,
      formatter: function (data) {
        if (!data.length) {return null;}
        return data[0];
      }
    },{
      $dataIndex: 0,
      formatter: function (data) {
        if (!data.length) {return null;}
        return data[1];
      }
    }
    ],
    series: [
      s1,
      s2
    ]
  };
}
export function threeCircle() {
  var s1 = series.getSingleArc();
  s1.animation = animation;

  var s2 = series.getSingleArc('arc2');
  s2.$dataIndex = 2;
  s2.center[0] = '50%';
  s2.animation = animation;

  var s3 = series.getSingleArc('arc3');
  s3.$dataIndex = 3;
  s3.center[0] = '75%';
  s3.animation = animation;

  return {
    preventDefaultMouseWheel: false,
    textStyle: {
        fontFamily: fontFamily
    },
    animation: animation,
    data: [{
      originData: [{
        min: 0,
        max: 100,
        title: '88环保',
        values: [
          { value: 80 }
        ]
      },{
        min: 0,
        max: 100,
        title: '节能环保',
        values: [
          { value: 8 }
        ]
      },{
        min: 0,
        max: 100,
        title: '公共安全',
        values: [
          { value: 18 }
        ]
      }]
    },{
      $dataIndex: 0,
      formatter: function (data) {
        if (!data.length) {return null;}
        return data[0];
      }
    },{
      $dataIndex: 0,
      formatter: function (data) {
        if (!data.length) {return null;}
        return data[1];
      }
    },{
      $dataIndex: 0,
      formatter: function (data) {
        if (!data.length) {return null;}
        return data[2];
      }
    }
    ],
    series: [
      s1,
      s2,
      s3
    ]
  };
}

export function fourCircle() {
  var s1 = series.getSingleArc();
  s1.animation = animation;
  s1.center[0] = '12%';

  var s2 = series.getSingleArc('arc2');
  s2.$dataIndex = 2;
  s2.center[0] = '36%';
  s2.animation = animation;

  var s3 = series.getSingleArc('arc3');
  s3.$dataIndex = 3;
  s3.center[0] = '62%';
  s3.animation = animation;

  var s4 = series.getSingleArc('arc4');
  s4.$dataIndex = 4;
  s4.center[0] = '88%';
  s4.animation = animation;

  return {
    preventDefaultMouseWheel: false,
    textStyle: {
        fontFamily: fontFamily
    },
    animation: animation,
    data: [{
      originData: [{
        min: 0,
        max: 100,
        title: '88环保',
        values: [
          { value: 80 }
        ]
      },{
        min: 0,
        max: 100,
        title: '节能环保',
        values: [
          { value: 8 }
        ]
      },{
        min: 0,
        max: 100,
        title: '公共安全',
        values: [
          { value: 18 }
        ]
      },{
        min: 0,
        max: 100,
        title: '公共aa安全',
        values: [
          { value: 18 }
        ]
      }]
    },{
      $dataIndex: 0,
      formatter: function (data) {
        if (!data.length) {return null;}
        return data[0];
      }
    },{
      $dataIndex: 0,
      formatter: function (data) {
        if (!data.length) {return null;}
        return data[1];
      }
    },{
      $dataIndex: 0,
      formatter: function (data) {
        if (!data.length) {return null;}
        return data[2];
      }
    },
    {
      $dataIndex: 0,
      formatter: function (data) {
        if (!data.length) {return null;}
        return data[3];
      }
    }
    ],
    series: [
      s1,
      s2,
      s3,
      s4
    ]
  };
}

export function hgArc() {
  return {
    preventDefaultMouseWheel: false,
    data: [{
      originData: {
        value: 0
      }
    }],
    series: [
      {
        animation: animation,
        type: 'gauge',
        $dataIndex: 0,
        radius: '40%',
        startAngle: -235, // 起始位置
        endAngle: 55, // 终止位置
        center: ['50%', '55%'],
        tickOffset: -8,
        gradient: true,
        splitNumber: 4,
        // 设置多个渐变颜色
        color: [[0, '#2B272A'], [1, '#95352E']],
        detail: {
          formatter: function (d) {
            let info = ''
            if (d >= 0 && d < 25) {
              info = '中长期风险较高'
            } else if (d >= 25 && d <= 75) {
              info = '中长期风险适中'
            } else {
              info = '中长期风险较低'
            }
            return '{a|'+ d +'} {b|分}\n{c|'+ info +'}';
          },
          style: { // {Object} 样式
            fill: '#FFFFFF',
            fontSize: 20,
            textAlign: 'center',
            // textVerticalAlign: 'center',
            fontFamily: fontFamily,
            rich: {
              a: {
                fontFamily: fontFamily,
                fill: '#fff',
                fontSize: 48,
                fontWeight: 900
              },
              b: {
                fill: '#fff',
                fontSize: 16,
                textPadding: [-14, 0,0,0]
              },
              c: {
                fill: '#a6a9ae',
                fontSize: 12,
                textLineHeight: 24
              }
            }
          }
        },
        axisLine: { // 仪表盘轴线相关配置。
          show: true, // {boolean} 是否显示
          style: { // {Object} 样式
            lineWidth: 35 // {number} arc 宽度
          }
        },
        arcOutline:{ // 圆弧完整背景
          show: true,
          style:{
            fill: '#25262A',
            stroke: '#434448'
          }
        },
        endArc: { // 圆弧结束位置高亮
          show: true,
          angleCross: 2, // {number} 度 360度为分母
          style: {
            fill: '#FD4332',
            stroke: '#FD4332'
          }
        },
        splitLine: { // 分隔线样式。
          show: true, // {boolean} 是否显示
          gradient: true,
          type: 'circle', // tick || circle
          length: 1.5, // {string|number} 分隔线线长。支持相对半径的百分比。
          color: [[0, '#202126'], [0.5, '#0096FF'], [1, '#202126']],
          style: { // {Object} 样式
            fill: '#0585DF',
            stroke: '#0585DF'
          }
        },
        axisTick: { // 刻度样式。
          show: true, // {boolean} 是否显示
          gradient: true,
          type: 'circle', // tick || circle
          splitNumber: 10, // {number} 分隔线之间分割的刻度数。
          length: 1.5, // {number} 刻度线长。支持相对半径的百分比。如果type是circle，则为半径
          color: [[0, '#202126'], [0.5, '#0096FF'], [1, '#202126']],
          style: {
            fill: '#0585DF',
            stroke: '#0585DF'
          }
        },
        axisLabel: { // 刻度标签。
          show: true,
          distance: -15, // {number} 标签与刻度线的距离。
          style: {
            fontSize: 10,
            fill: '#0096FF',
            textAlign: 'center',
            textVerticalAlign: 'center'
          }
        }
      }
    ]
  }
}

export function zgArc() {
  return {
    preventDefaultMouseWheel: false,
    textStyle:{
      fontFamily: fontFamily
    },
    data: [{
      originData: {
        value: 0,
      }
    }],
    series: [
      {
        type: 'gauge',
        $dataIndex: 0,
        radius: '40%',
        startAngle: -235, // 起始位置
        endAngle: 55, // 终止位置
        center: ['50%', '55%'],
        tickOffset: -8,
        animation: animation,
        gradient: true,
        splitNumber: 4,
        // 设置多个渐变颜色
        color: [[0, '#2B272A'], [1, '#95352E']],
        detail: {
          formatter: function (d) {
            let info = ''
            if (d >= 0 && d < 25) {
              info = '短期风险较高'
            } else if (d >= 25 && d <= 75) {
              info = '短期风险适中'
            } else {
              info = '短期风险较低'
            }
            return '{a|'+ d +'} {b|分}\n{c|'+ info +'}';
          },
          style: { // {Object} 样式
            fill: '#FFFFFF',
            fontSize: 20,
            fontFamily: fontFamily,
            textAlign: 'center',
            rich: {
              a: {
                fontFamily: fontFamily,
                fill: '#fff',
                fontSize: 48,
                fontWeight: 900
              },
              b: {
                fill: '#fff',
                fontSize: 16,
                textPadding: [-14,0,0,0]
              },
              c: {
                fill: '#a6a9ae',
                fontSize: 12,
                textLineHeight: 24
              }
            }
          }
        },
        axisLine: { // 仪表盘轴线相关配置。
          show: true, // {boolean} 是否显示
          style: { // {Object} 样式
            lineWidth: 35 // {number} arc 宽度
          }
        },
        arcOutline:{ // 圆弧完整背景
          show: true,
          style:{
            fill: '#25262A',
            stroke: '#434448'
          }
        },
        endArc: { // 圆弧结束位置高亮
          show: true,
          angleCross: 2, // {number} 度 360度为分母
          style: {
            fill: '#FD4332',
            stroke: '#FD4332'
          }
        },
        splitLine: { // 分隔线样式。
          show: true, // {boolean} 是否显示
          gradient: true,
          type: 'circle', // tick || circle
          length: 1.5, // {string|number} 分隔线线长。支持相对半径的百分比。
          color: [[0, '#202126'], [0.5, '#0096FF'], [1, '#202126']],
          style: { // {Object} 样式
            fill: '#0585DF',
            stroke: '#0585DF'
          }
        },
        axisTick: { // 刻度样式。
          show: true, // {boolean} 是否显示
          gradient: true,
          type: 'circle', // tick || circle
          splitNumber: 10, // {number} 分隔线之间分割的刻度数。
          length: 1.5, // {number} 刻度线长。支持相对半径的百分比。如果type是circle，则为半径
          color: [[0, '#202126'], [0.5, '#0096FF'], [1, '#202126']],
          style: {
            fill: '#0585DF',
            stroke: '#0585DF'
          }
        },
        axisLabel: { // 刻度标签。
          show: true,
          distance: -15, // {number} 标签与刻度线的距离。
          style: {
            fontSize: 10,
            fill: '#0096FF',
            textAlign: 'center',
            textVerticalAlign: 'center'
          }
        }
      }
    ]
  }
}
